import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import resourcesToBackend from "i18next-resources-to-backend"

export function initI18next(lng: string) {
  return i18next.isInitialized
    ? Promise.resolve()
    : i18next
        .use(initReactI18next)
        .use(
          resourcesToBackend((language: string, namespace: string) => {
            /**
             * TODO: This is a temporary fix. Remove when we find a better solution.
             *
             * @see https://linear.app/autouncle/issue/DL-2165/proprely-fix-swedish-locale-mapping-in-i18next
             */
            const lang =
              language === "sv-SE" || language === "sv" ? "se" : language

            return import(`../locales/${lang}/${namespace}.json`)
          })
        )
        .init({
          // debug: true,
          lng,
          fallbackLng: [],
          interpolation: {
            escapeValue: false,
            prefix: "%{",
            suffix: "}",
          },
          partialBundledLanguages: true,
          /**
           * we need to specify the `defaultNS`,
           * otherwise it will default to `"translation"` (lib default),
           * which will cause an error (we do not have such a namespace)
           * @see https://linear.app/autouncle/issue/DL-1384/chore-add-namespace-for-shared-translations
           */
          defaultNS: "lead_conversion_flows",
          /**
           * Namespaces that are not added here are loaded asynchronously on demand
           * If you don't add a namespace here, it expects a Suspense because the component cannot be rendered synchronously
           */
          ns: ["component_library", "lead_conversion_flows", "lead_insights"],
          resources: {},
        })
}

export default i18next
